import React from 'react';
import _ from 'lodash';
import UrlParse from 'url-parse';
import Loading from '../../components/loading';
import LabelHelper from '../../helpers/Label';
import OptionHelper from '../../helpers/Option';
import GeneralHelper from '../../helpers/general';
import { Space } from 'antd';
import { Button, Table, Select, Row, Badge, Input } from 'antd';
import { SearchOutlined, PlusSquareOutlined } from '@ant-design/icons';

import ListLayout from '../../layouts/list-layout';
import { Link } from 'react-router-dom';

const ENTRY_PER_PAGE = 10000;

class EquipmentListPage extends React.Component {
	state = {
		channel: '',
		type: '',
		status: '',
		location: '',
		equipment: ''
	};

	initialState = {...this.state};

	componentDidMount() {
		this.getEquipments();
	}

	componentDidUpdate(prevProps) {
		const { crf_id: prevCrfId } = prevProps.drawerReducer;
		const { crf_id: newCrfId } = this.props.drawerReducer;
		// check hall_id / bldg_cde if change to change what the user will see
		if(prevCrfId !== newCrfId) {
			this.setState(this.initialState);
			this.props.resetPage();
			this.getEquipments();
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	getEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const {
			page,
			limit
		} = opts || {};

		this.props.getEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE
		});
	}

	getFilteredEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const { channel, type, status, location, equipment } = this.state;
		const {
			page,
			limit
		} = opts || {};

		this.props.getFilteredEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE,
			search: {
				...(channel && {channel}),
				...(type && {type}),
				...(status && {status}),
				...(location && {location_id: location}),
				...(equipment && {name: equipment})
			}
		});
	}

	onFieldChange = (data) => {
		if(data.name === 'equipment') {
			this.setState({ ...this.state, [data.name]: GeneralHelper.toNormalCase(data.value) });
			return;
		}
		this.setState({ ...this.state, [data.name]: data.value });
	};

	render() {
		const { loading, equipments, filteredEquipments, search } = this.props.pageProps;
		const { channel, type, status, location, equipment } = this.state;

		// if no render dataIndex is a must....
		const columns = [
			{
				title: 'Equipment',
				dataIndex: 'name',
				key: 'name',
				render: (name) => GeneralHelper.truncateString(name, 75)
			},
			{
				title: 'Equipment Identifier',
				dataIndex: 'slug',
				key: 'slug',
				render: (slug) => GeneralHelper.truncateString(slug)
			},
			{
				title: 'Location',
				key: 'location',
				render: data => {
					const { location: {name} } = data;
					return (
						<Space size="middle">
							<p> {GeneralHelper.truncateString(name)} </p>
						</Space>
					);
				}
			},
			{
				title: 'Equipment Type',
				key: 'type',
				render: data => {
					return (
						<Space size="middle">
							<p> {LabelHelper.bookingType(data.type)} </p>
						</Space>
					);
				}
			},
			{
				title: 'IP Address',
				dataIndex: 'controller_ip',
				key: 'controller_ip'
			},
			{
				title: 'Port',
				dataIndex: 'port',
				key: 'port',
				align: 'center'
			},
			{
				title: 'Relay Box Channel',
				dataIndex: 'channel',
				key: 'channel',
				align: 'center'
			},
			{
				title: 'Status',
				key: 'status',
				width: '105px',
				render: data => {
					const { status } = data;
					return (
						<Space size="middle">
							<p>
								<Badge
									color={
										status==='enabled' ? 'green' : 'red' }
								/> {LabelHelper.equipmentStatus(status)} </p>
						</Space>
					);
				}
			},
			{
				title: 'Actions',
				key: 'actions',
				render: data => {
					return (
						<Space size="middle">
							<Link to={`/equipments/id/basic?id=${data._id}`}> Edit </Link>
						</Space>
					);
				}
			}
		];

		const equipment_channel = _.uniqBy(equipments, 'channel').map(equipment => {
			return {
				value: equipment.channel,
				text: equipment.channel
			};
		});
		const equipment_type = _.uniqBy(equipments, 'type').map(equipment => {
			return {
				value: equipment.type,
				text: LabelHelper.bookingType(equipment.type)
			};
		});
		const equipmentLocation = _.uniqBy(equipments, 'location_id').map(equipment => {
			return {
				value: equipment.location_id,
				text: equipment.location.name
			};
		});

		return(
			<>
				<ListLayout
					title="Equipment"
				>
					{ loading ?
						<Loading /> :
						<>
							<Row
								justify="end"
								style={{ paddingBottom: 10, paddingTop: 10, paddingRight: 12 }}
							>
								<Select
									placeholder="Search by Box Channel"
									optionFilterProp="children"
									{...channel !== '' && {defaultValue: channel}}
									onChange={(value) => {
										const data = {
											name: 'channel',
											value
										};
										this.onFieldChange(data);
									}}
									style={{ width: 250, marginTop: 5, marginRight: 10 }}
									filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
									allowClear
								>
									{equipment_channel.map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
								<Select
									placeholder="Search by Equipment Type"
									optionFilterProp="children"
									{...type !== '' && {value: type}}
									onChange={(value) => {
										const data = {
											name: 'type',
											value
										};
										this.onFieldChange(data);
									}}
									style={{ width: 230, marginTop: 5, marginRight: 10 }}
									filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
									allowClear
								>
									{equipment_type.map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
								<Select
									placeholder="Search by Status"
									optionFilterProp="children"
									{...status !== '' && {value: status}}
									onChange={(value) => {
										const data = {
											name: 'status',
											value
										};
										this.onFieldChange(data);
									}}
									style={{ width: 180, marginTop: 5, marginRight: 10 }}
									filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
									allowClear
								>
									{OptionHelper.equipmentStatus().map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
								<Select
									placeholder="Search by Location"
									optionFilterProp="children"
									{...location !== '' && {value: location}}
									onChange={(value) => {
										const data = {
											name: 'location',
											value
										};
										this.onFieldChange(data);
									}}
									style={{ width: 180, marginTop: 5, marginRight: 10 }}
									filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
									allowClear
								>
									{equipmentLocation.map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
								<Input
									placeholder="Search Equipment"
									{...equipment !== '' && {value: equipment}}
									onChange={(e) => {
										const data = {
											name: 'equipment',
											value: e.target.value
										};
										this.onFieldChange(data);
									}}
									style={{ maxWidth: 250, marginRight: 10, marginTop: 5 }}
									maxLength={75}
									allowClear
								/>
								<Button
									icon={<SearchOutlined />}
									style={{ background: '#003366', color: '#ffffff', marginRight: 10, marginTop: 5 }}
									onClick={this.getFilteredEquipments}
								>
									Search
								</Button>
								<Button
									onClick={() => this.props.history.push('/equipments/create')}
									icon={<PlusSquareOutlined />}
									style={{ background: '#003366', color: '#ffffff', marginRight: 10, marginTop: 5 }}
								>
									New Equipment
								</Button>
							</Row>
							<Table
								rowKey={equipment => equipment._id}
								columns={columns}
								dataSource={search ? filteredEquipments : equipments }
								style={{ width: '100%', marginTop: 5, paddingRight: 20, paddingLeft: 20 }}
								scroll={{ x: 400 }}
							/>
						</>
					}
				</ListLayout>
				<div className="copyright">
					<p>Copyright &copy; The Hong Kong University of Science and Technology. <em>All rights reserved.</em></p>
				</div>
			</>
		);
	}
}

export default EquipmentListPage;
